import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { AppBar, Box, IconButton, Stack } from "@mui/material";
import * as React from "react";
import { Link } from "react-router-dom";

import HeaderBalanceChip from "@/components/HeaderBalanceChip";
import NotificationMenu from "@/components/NotificationMenu";
import { ROUTES } from "@/constants";
import { useTranslation } from "@/context/I18nProvider";
import { useAppLogo } from "@/hooks";
import SideMenuMobile from "@/layout/Sidebar/Mobile";
import { Toolbar } from "@/theme";

export default function AppNavbar() {
  const { t } = useTranslation();
  const logoSrc = useAppLogo();
  const [open, setOpen] = React.useState<boolean>(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        display: { xs: "auto", md: "none" },
        boxShadow: 0,
        bgcolor: "background.paper",
        backgroundImage: "none",
        borderBottom: "1px solid",
        borderColor: "divider",
        top: "var(--template-frame-height, 0px)",
      }}
    >
      <Toolbar variant="regular">
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            flexGrow: 1,
            width: "100%",
            gap: 1,
          }}
        >
          <Box component={Link} to={ROUTES.HOME} sx={{ display: "flex", flexShrink: 0 }}>
            <Box component="img" src={logoSrc} alt="SkyStake" sx={{ height: 28, width: "auto" }} />
          </Box>
          <Stack direction="row" alignItems="center" gap={0.5} sx={{ ml: "auto", minWidth: 0 }}>
            <HeaderBalanceChip />
            <NotificationMenu />
            <IconButton size="small" aria-label={t("common.menu")} onClick={toggleDrawer(true)}>
              <MenuRoundedIcon />
            </IconButton>
          </Stack>
          <SideMenuMobile open={open} toggleDrawer={toggleDrawer} />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
